import { Component, OnInit } from '@angular/core';
import { MiscService } from 'src/app/_service/misc.service';
import { SharedService } from 'src/app/_service/shared.service';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DentalService } from 'src/app/_service/dental.service';
import { LeadsService } from 'src/app/_service/leads.service';
declare var $: any;


@Component({
  selector: 'app-add-edit-pincode-scanpro-master',
  templateUrl: './add-edit-pincode-scanpro-master.component.html',
  styleUrls: ['./add-edit-pincode-scanpro-master.component.css']
})
export class AddEditPincodeScanproMasterComponent implements OnInit {

  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false;
  daysList: any;
  zoneScanProForm: FormGroup; submitted: boolean = false; loading: boolean = false; circles: any; circles_copy: any;
  zones: any; zones_copy: any; allscanproUser: any; allscanproUser_copy: any; scanproId: any = ''; disableSelect: any = []; 
  constructor(private leadapi: LeadsService, public dentalapi: DentalService, private activatedRoute: ActivatedRoute, public miscapi: MiscService, public sharedapi: SharedService, private formBuilder: FormBuilder, private router: Router) {
    this.daysList = [
      { value: "Sun", name: "Sunday" },
      { value: "Mon", name: "Monday" },
      { value: "Tue", name: "Tuesday" },
      { value: "Wed", name: "Wednesday" },
      { value: "Thu", name: "Thursday" },
      { value: "Fri", name: "Friday" },
      { value: "Sat", name: "Saturday" }
    ]

    this.zoneScanProForm = this.formBuilder.group({
      'circle_id': [null, Validators.required],
      'zone_id': [null, Validators.required],
      'scanprouser_id': [null, Validators.required],
      'bookingDays': this.formBuilder.array([])

    });

    this.activatedRoute.params.subscribe(params => {
      if (params['scanpro_id']) {
        this.scanproId = params['scanpro_id'];
        this.patchZoneScanProData(this.scanproId);
      }
    });

  }
  ngOnInit(): void {
    this.getcircle();
    this.getScanProUser();
  }

  get f() { return this.zoneScanProForm.controls; }

  async createZoneScanPro() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.zoneScanProForm.invalid) {
      this.loading = false;
      return;
    }
    this.scanproId = this.activatedRoute.snapshot.paramMap.get('scanpro_id');
    this.zoneScanProForm.value.id = parseInt(this.scanproId);
    await this.miscapi.saveZoneScanPro(this.zoneScanProForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.router.navigateByUrl('/zone-scanpro-master-list');
        this.zoneScanProForm.reset();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getCircleZone(circle_id) {
    let qString = 'circle=' + circle_id;
    await this.miscapi.getCircle_zone(qString).subscribe((data: any) => {
      if (data.status) {
        this.zones = data.data;
        this.zones_copy = this.zones;
      } else {
        this.zones = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getScanProUser() {
    await this.dentalapi.getscanprouser().subscribe((data: any) => {
      if (data.status) {
        this.allscanproUser = data.data;
        this.allscanproUser_copy = this.allscanproUser;
      } else {
        this.allscanproUser = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  searchOnSelect(searchtText: any, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'zones') {
      this.zones = this.sharedapi.searchData(searchtText, this.zones_copy, "zone_name");
    } else if (type == 'scanpro') {
      this.allscanproUser = this.sharedapi.searchData(searchtText, this.allscanproUser_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'zone') {
      $("#zoneSearch").val('');
      $("#zoneSearch").focus();
      this.zones = this.zones_copy;
    } else if (type == 'scanpro') {
      $("#scanproSearch").val('');
      $("#scanproSearch").focus();
      this.allscanproUser = this.allscanproUser_copy;
    }
  }

  bookingDays(): FormArray {
    console.log();
    return this.zoneScanProForm.get("bookingDays") as FormArray
  }

  newQuantity(): FormGroup {
    return this.formBuilder.group({
      days_list: '',
      no_of_booking: '',
      from_time: '',
      to_time: ''
    })
  }

  addQuantity() {
    this.bookingDays().push(this.newQuantity());
    let getIndex = this.zoneScanProForm.controls["bookingDays"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }

  removeQuantity(i: number) {
    this.bookingDays().removeAt(i);
  }

  async patchZoneScanProData(scanproId) {
    await this.miscapi.getZoneScanProEditData(this.scanproId).subscribe((response: any) => {
      if (response.status) {
        console.log(response);
        this.getCircleZone(response.data[0].circle_id);
        this.zoneScanProForm.patchValue({
          'circle_id': response.data[0].circle_id,
          'zone_id': response.data[0].zone_id,
          'scanprouser_id': response.data[0].scanprouser_id,
        });
        if (response.data[0].days) {
          let controlArray = this.zoneScanProForm.get('bookingDays') as FormArray;
          response.data.forEach((element, index) => {
            controlArray.push(this.formBuilder.group({
              days_list: element.days,
              no_of_booking: element.no_of_booking,
              from_time: element.from_time,
              to_time: element.to_time
            }));

          });
        }
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


}
